import { NavLink } from "react-router-dom";

export const SweepStakesTos = () => {
  return (
    <div className="flex flex-col w-full p-4 desktop:p-8 max-w-[1000px] mx-auto gap-y-12 mt-4 mb-12">
      <section className="space-y-4">
        <h1 className="text-3xl font-semibold">
          Sweepstakes Terms and Conditions
        </h1>

        <h3 className="text-lg font-semibold">1. Introduction</h3>
        <p>
          Welcome to the EasySBC Sweepstakes ("Sweepstakes"). By entering, you
          agree to these Terms & Conditions and our Privacy Policy. Please read
          them carefully before participating.
        </p>

        <h3 className="text-lg font-semibold">2. Sponsor</h3>
        <p>
          The Sweepstakes is organized and sponsored by PearEasy ApS,
          Copenhagen, Denmark ("Sponsor", "we", "us", or "our").
        </p>
        <p>
          This Sweepstakes is in no way sponsored, endorsed, administered by, or
          associated with Electronic Arts Inc. ("EA").
        </p>

        <h3 className="text-lg font-semibold">3. Eligibility</h3>
        <ul className="list-disc pl-6 space-y-2">
          <li>
            <strong>Age:</strong> Open to individuals who are of legal age in
            their country of residence.
          </li>
          <li>
            <strong>Residency:</strong> Open to residents of countries where
            such sweepstakes are legally permitted. Entries from countries under
            EU or US sanctions are not eligible.
          </li>
          <li>
            <strong>Exclusions:</strong> Employees, officers, and directors of
            Sponsor, its affiliates, and their immediate families are not
            eligible.
          </li>
        </ul>

        <h3 className="text-lg font-semibold">4. Sweepstakes Period</h3>
        <p>
          The Sweepstakes begins on{" "}
          <strong>September 1, 2025, at 12:00 AM CET</strong> and ends on{" "}
          <strong>September 8, 2025, at 11:59 PM CET</strong> ("Sweepstakes
          Period"). Entries received outside this period will not be considered.
        </p>

        <h3 className="text-lg font-semibold">5. How to Enter</h3>
        <p>
          To participate, sign up via the entry form provided by EasySBC. By
          entering, you agree to receive marketing communications and emails
          from EasySBC. No purchase is necessary to enter or win.
        </p>

        <h3 className="text-lg font-semibold">6. Prizes</h3>
        <ul className="list-disc pl-6 space-y-2">
          <li>
            <strong>Number of Prizes:</strong> Three (3) prizes will be awarded.
          </li>
          <li>
            <strong>Prize Details:</strong> Each prize consists of one (1) EA
            SPORTS FC 26 Ultimate Edition (digital code or gift card equivalent,
            subject to regional availability).
          </li>
          <li>
            <strong>Conditions:</strong> Prizes are non-refundable,
            non-transferable, and cannot be exchanged for cash. Availability
            depends on regional restrictions and stock.
          </li>
          <li>
            <strong>Limit:</strong> One (1) prize per person.
          </li>
        </ul>

        <h3 className="text-lg font-semibold">7. Odds of Winning</h3>
        <p>
          Odds of winning depend on the number of eligible entries received.
        </p>

        <h3 className="text-lg font-semibold">
          8. Winner Selection and Notification
        </h3>
        <p>
          Winners will be selected at random after the Sweepstakes Period.
          Winners will be notified via the contact details provided upon entry
          within five (5) business days. If a winner does not respond within ten
          (10) business days, an alternate winner may be selected.
        </p>

        <h3 className="text-lg font-semibold">9. Data & Privacy</h3>
        <ul className="list-disc pl-6 space-y-2">
          <li>Sponsor is the data controller.</li>
          <li>
            Data collected will be used to manage the Sweepstakes and for
            EasySBC marketing communications.
          </li>
          <li>
            By entering, participants agree that their personal data may be
            processed in accordance with GDPR and our Privacy Policy.
          </li>
          <li>
            Participants may withdraw consent or request data deletion by
            contacting{" "}
            <a
              href="mailto:support@easysbc.io"
              className="text-primary-blue cursor-pointer"
            >
              support@easysbc.io
            </a>
            .
          </li>
        </ul>

        <h3 className="text-lg font-semibold">
          10. Release & Limitation of Liability
        </h3>
        <p>
          By participating, you release and hold harmless Sponsor, its
          affiliates, and EA from any claims arising out of participation or use
          of the prize.
        </p>

        <h3 className="text-lg font-semibold">11. Governing Law</h3>
        <p>
          These Terms are governed by the laws of Denmark. Any disputes shall be
          subject to the exclusive jurisdiction of the Danish courts.
        </p>

        <h3 className="text-lg font-semibold">12. Amendments</h3>
        <p>
          Sponsor reserves the right to modify or cancel the Sweepstakes at any
          time without notice.
        </p>

        <h3 className="text-lg font-semibold">13. Contact</h3>
        <p>
          PearEasy ApS
          <br />
          <br />
          Registration Number: DK43087037
          <br />
          Copenhagen, Denmark
          <br />
          Email:{" "}
          <a
            href="mailto:support@easysbc.io"
            className="text-primary-blue cursor-pointer"
          >
            support@easysbc.io
          </a>
        </p>
      </section>
    </div>
  );
};
